import { useState, useCallback } from 'react';
import { uploadArquivo, deletarArquivo as apiDeletar } from '../api/arquivo';
import type { CategoriaArquivo, ArquivoFormulario } from '@engenharia/shared';
import { toast } from 'react-toastify';

interface UploadState {
  uploading: boolean;
  progress: number;
}

export function useFileUpload(formularioId: number | null) {
  const [states, setStates] = useState<Record<string, UploadState>>({});

  const upload = useCallback(
    async (categoria: CategoriaArquivo, file: File): Promise<number | null> => {
      if (!formularioId) {
        toast.error('Salve o formulário antes de enviar arquivos');
        return null;
      }

      setStates((prev) => ({ ...prev, [categoria]: { uploading: true, progress: 0 } }));

      try {
        const result = await uploadArquivo(formularioId, categoria, file, (pct) => {
          setStates((prev) => ({ ...prev, [categoria]: { uploading: true, progress: pct } }));
        });
        toast.success(`Arquivo enviado: ${file.name}`);
        return result.id;
      } catch (err) {
        toast.error('Erro ao enviar arquivo');
        return null;
      } finally {
        setStates((prev) => ({ ...prev, [categoria]: { uploading: false, progress: 0 } }));
      }
    },
    [formularioId]
  );

  const deletar = useCallback(async (arquivoId: number) => {
    try {
      await apiDeletar(arquivoId);
      toast.success('Arquivo removido');
      return true;
    } catch {
      toast.error('Erro ao remover arquivo');
      return false;
    }
  }, []);

  return { upload, deletar, states };
}
